export var ThemeEnum;
(function (ThemeEnum) {
    ThemeEnum["DARK"] = "dark";
    ThemeEnum["LIGHT"] = "light";
    ThemeEnum["SYSTEM"] = "system";
})(ThemeEnum || (ThemeEnum = {}));
export var ButtonTypeEnum;
(function (ButtonTypeEnum) {
    ButtonTypeEnum["Link"] = "Link";
    ButtonTypeEnum["button"] = "button";
    ButtonTypeEnum["a"] = "a";
    ButtonTypeEnum["ref"] = "ref";
})(ButtonTypeEnum || (ButtonTypeEnum = {}));
export var TableCellContentAlignEnum;
(function (TableCellContentAlignEnum) {
    TableCellContentAlignEnum["LEFT"] = "left";
    TableCellContentAlignEnum["RIGHT"] = "right";
    TableCellContentAlignEnum["CENTER"] = "center";
    TableCellContentAlignEnum["JUSTIFY"] = "justify";
})(TableCellContentAlignEnum || (TableCellContentAlignEnum = {}));
export var RolesEnum;
(function (RolesEnum) {
    RolesEnum["SUPER_ADMIN"] = "SuperAdmin";
    RolesEnum["SALESPERSON"] = "Salesperson";
})(RolesEnum || (RolesEnum = {}));
export var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["READ"] = "read";
    PermissionsEnum["WRITE"] = "write";
    PermissionsEnum["DELETE"] = "delete";
    PermissionsEnum["UPDATE"] = "update";
    PermissionsEnum["CREATE"] = "create";
    PermissionsEnum["ALL"] = "all";
})(PermissionsEnum || (PermissionsEnum = {}));
export var CompanyDomainStatusEnum;
(function (CompanyDomainStatusEnum) {
    CompanyDomainStatusEnum["UNAVAILABLE"] = "unavailable";
    CompanyDomainStatusEnum["UNKNOWN"] = "unknown";
    CompanyDomainStatusEnum["ONLINE"] = "ONLINE";
})(CompanyDomainStatusEnum || (CompanyDomainStatusEnum = {}));
export var ExportTypeEnum;
(function (ExportTypeEnum) {
    ExportTypeEnum["EXCEL"] = "excel";
    ExportTypeEnum["CSV"] = "csv";
    ExportTypeEnum["JSON"] = "json";
})(ExportTypeEnum || (ExportTypeEnum = {}));
export var CompanyFeaturesEnum;
(function (CompanyFeaturesEnum) {
    CompanyFeaturesEnum["BASIC_SYSTEM_ACCESS"] = "BASIC_SYSTEM_ACCESS";
    CompanyFeaturesEnum["PREMIUM_DATA_VISUALIZATIONS"] = "PREMIUM_DATA_VISUALIZATIONS";
    /** Several phone numbers per person, and texts to each confirmed one. Rollout flag. */
    CompanyFeaturesEnum["MULTIPLE_PHONE_NUMBERS"] = "MULTIPLE_PHONE_NUMBERS";
})(CompanyFeaturesEnum || (CompanyFeaturesEnum = {}));
export var FormTypeEnum;
(function (FormTypeEnum) {
    FormTypeEnum["FROM_SCRATCH"] = "from-scratch";
    FormTypeEnum["FROM_AI"] = "from-ai";
})(FormTypeEnum || (FormTypeEnum = {}));
export var AppEnum;
(function (AppEnum) {
    AppEnum["CLIENT"] = "client";
    AppEnum["SUPER_ADMIN_PORTAL"] = "super-admin";
})(AppEnum || (AppEnum = {}));
export var FormFieldTypeEnum;
(function (FormFieldTypeEnum) {
    FormFieldTypeEnum["TEXT"] = "text";
    FormFieldTypeEnum["TEXTAREA"] = "textarea";
    FormFieldTypeEnum["RADIO"] = "radio";
    FormFieldTypeEnum["CHECKBOX"] = "checkbox";
    FormFieldTypeEnum["DROPDOWN"] = "dropdown";
    FormFieldTypeEnum["DATE"] = "date";
    FormFieldTypeEnum["TIME"] = "time";
    FormFieldTypeEnum["DATETIME"] = "datetime";
    FormFieldTypeEnum["NUMBER"] = "number";
    FormFieldTypeEnum["EMAIL"] = "email";
    FormFieldTypeEnum["PHONE"] = "phone";
    FormFieldTypeEnum["URL"] = "url";
    FormFieldTypeEnum["FILE"] = "file";
    FormFieldTypeEnum["IMAGE"] = "image";
    FormFieldTypeEnum["SIGNATURE"] = "signature";
    FormFieldTypeEnum["PASSWORD"] = "password";
    FormFieldTypeEnum["HIDDEN"] = "hidden";
})(FormFieldTypeEnum || (FormFieldTypeEnum = {}));
export var TourNamesEnum;
(function (TourNamesEnum) {
    TourNamesEnum["SETUP_COMPANY"] = "setup-company";
    TourNamesEnum["ADD_A_ROLE"] = "add-a-role";
    TourNamesEnum["GENERATE_A_REPORT"] = "generate-a-report";
    TourNamesEnum["CREATE_A_NEW_TEMPLATE"] = "create-a-new-template";
})(TourNamesEnum || (TourNamesEnum = {}));
export var QuestionTypeEnum;
(function (QuestionTypeEnum) {
    QuestionTypeEnum["SELECT_ONE"] = "select one";
    QuestionTypeEnum["SELECT_MANY"] = "select many";
    QuestionTypeEnum["LONG_TEXT"] = "long text";
    QuestionTypeEnum["SHORT_TEXT"] = "short text";
    /**
     * A calendar date, stored as a timezone-free 'YYYY-MM-DD' string.
     *
     * Not a Date: a date of incident is a calendar fact, and converting it to an
     * instant shifts it by a day for anyone west of UTC. The string form also
     * rides every path a text answer already rides, and the xlsx export already
     * recognises it as a date column.
     */
    QuestionTypeEnum["DATE"] = "date";
    /**
     * A point on an ordered scale, stored as the number itself rather than an
     * option id. The range and direction live on the question's `scale`.
     *
     * NPS is a preset of this, not a type of its own: eleven points labelled
     * 0-10 is still a scale, and giving it a type would mean a second way to
     * express the same answer.
     */
    QuestionTypeEnum["SCALE"] = "scale";
    /** A plain quantity. Unanswered is null, never 0. */
    QuestionTypeEnum["NUMBER"] = "number";
})(QuestionTypeEnum || (QuestionTypeEnum = {}));
export var DomainProvisioningStatus;
(function (DomainProvisioningStatus) {
    DomainProvisioningStatus["UNKNOWN"] = "unknown";
    DomainProvisioningStatus["PENDING"] = "pending";
    DomainProvisioningStatus["PROVISIONED"] = "provisioned";
    DomainProvisioningStatus["FAILED"] = "failed";
})(DomainProvisioningStatus || (DomainProvisioningStatus = {}));
export var TargetAudienceTypeEnum;
(function (TargetAudienceTypeEnum) {
    TargetAudienceTypeEnum["INDIVIDUAL"] = "individual";
    TargetAudienceTypeEnum["ROLE"] = "role";
    TargetAudienceTypeEnum["ORGANIZATION"] = "organization";
})(TargetAudienceTypeEnum || (TargetAudienceTypeEnum = {}));
export var AuthStatusEnum;
(function (AuthStatusEnum) {
    AuthStatusEnum["Pending"] = "pending";
    AuthStatusEnum["Authenticated"] = "authenticated";
    AuthStatusEnum["Unauthenticated"] = "unauthenticated";
    AuthStatusEnum["Error"] = "error";
})(AuthStatusEnum || (AuthStatusEnum = {}));
